function Bermuda({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_659)">
  <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z" fill="#D80027"/>
  <path d="M16 7.65234V13.0488L10.4348 7.65234H16Z" fill="#0052B4"/>
  <path d="M8.34785 16.0001H13.0485L8.34785 9.73926L7.65222 14.6088L8.34785 16.0001Z" fill="#0052B4"/>
  <path d="M15.9572 15.9998H16C16 15.9855 16 15.9715 16 15.957C15.9857 15.9713 15.9715 15.9856 15.9572 15.9998Z" fill="#F0F0F0"/>
  <path d="M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z" fill="#F0F0F0"/>
  <path d="M8.09467 2.08691C5.59223 3.51185 3.51179 5.59223 2.08691 8.09467V16.6956H6.26085V6.26098V6.26085H16.6956C16.6956 4.94442 16.6956 3.69029 16.6956 2.08691H8.09467Z" fill="#D80027"/>
  <path d="M16.636 14.6682L10.3153 8.34766H8.34778V8.34778L16.6358 16.6358H16.636C16.636 16.6359 16.636 15.2792 16.636 14.6682Z" fill="#D80027"/>
  <path d="M18.0869 8.34766V15.9998C18.0869 19.7273 27.826 19.7273 27.826 15.9998V8.34766H18.0869Z" fill="#F3F3F3"/>
  <path d="M18.0869 16.0001V16C18.0869 19.7275 22.9565 20.8696 22.9565 20.8696C22.9565 20.8696 27.826 19.7275 27.826 16V16.0001H18.0869Z" fill="#6DA544"/>
  <path d="M22.9566 12.939L20.6957 13.9129V15.9998L22.9566 17.3912L25.2174 15.9998V13.9129L22.9566 12.939Z" fill="#A2001D"/>
  <path d="M20.6957 11.8262H25.2174V13.9131H20.6957V11.8262Z" fill="#338AF3"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Bermuda;
